import { FINANCIAL_PRODUCT } from '@brighte/validation';
import E2515Logo from '../../../assets/logos/electrify-2515.svg?react';

export const getFinancialProductLogo = (financialProductId?: string) => {
  switch (financialProductId) {
    case FINANCIAL_PRODUCT.ELECTRIFY_2515:
      return <E2515Logo width={140} height={35} />;
    default:
      return null;
  }
};
